import { useEffect } from "react";

/**
 * Locks RivetAI page scroll roots (`data-page-scroll`) while an overlay is active.
 */
export function usePageScrollLock(locked: boolean): void {
  useEffect(() => {
    if (!locked) {
      return;
    }

    const scrollRoots = document.querySelectorAll<HTMLElement>(
      "[data-page-scroll], [data-panel-scroll]"
    );
    const previous = Array.from(scrollRoots).map((el) => ({
      el,
      overflow: el.style.overflow,
    }));

    scrollRoots.forEach((el) => {
      el.style.overflow = "hidden";
    });

    return () => {
      previous.forEach(({ el, overflow }) => {
        el.style.overflow = overflow;
      });
    };
  }, [locked]);
}
